import React, { Dispatch } from 'react';
import Translator from '../../../core/i18n';
import { Log } from 'ng2-logger';
import { IAppState, IAction } from '../../../models/action/core';
import { connect } from 'react-redux';
import { Common } from '../../../core/common';
import { Redirect } from 'react-router-dom';
import * as IFrameActions from '../../../store/actions/iFrameSource';
import Loading from '../../../components/loading/loading';
import { Collapse } from 'reactstrap';
import Tooltip from '../../../components/tooltip/main';

const _logger = Log.create('content.tsx');
const T = Translator.create();
let _common: Common;

export class ReportPage extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            query: '',
            isSearchBoxOpen: false,
            row1status: false,
            row2status: false,
            row3status: false,
            row4status: false,
            row5status: false,
            row6status: false,
            searchResults: [],
            reports: [
                {
                    type: 1,
                    name: T.t('r_report_lesson_process'),
                    description: T.t('r_report_lesson_process_info'),
                    isViewing: false,
                    redirectUrl: '/Course/ProgressReport',
                    reportTemplateGuid: ''
                },
                {
                    type: 1,
                    name: T.t('r_report_general_activity'),
                    description: T.t('r_report_general_activity_info'),
                    isViewing: false,
                    redirectUrl: '/Activity/ActivityReport',
                    reportTemplateGuid: ''
                },
                {
                    type: 1,
                    name: T.t('r_report_content_report'),
                    description: T.t('r_report_content_report_info'),
                    isViewing: false,
                    redirectUrl: '/Report/ActivityListReport',
                    reportTemplateGuid: ''
                },
                {
                    type: 1,
                    name: T.t('r_report_virtual_class_payment'),
                    description: T.t('r_report_virtual_class_payment_info'),
                    isViewing: false,
                    redirectUrl: '/VirtualClass/PaymentReport',
                    reportTemplateGuid: ''
                },
                {
                    type: 1,
                    name: T.t('r_report_general_process'),
                    description: T.t('r_report_general_process_info'),
                    isViewing: false,
                    redirectUrl: '/Report/OrganizationalUnit',
                    reportTemplateGuid: ''
                },
                {
                    type: 1,
                    name: T.t('r_report_teacher_detail_report'),
                    description: T.t('r_report_teacher_detail_report_info'),
                    isViewing: false,
                    redirectUrl: '/Report/TeacherEvaluationReport',
                    reportTemplateGuid: ''
                },
                {
                    type: 2,
                    name: T.t('r_report_active_year_student'),
                    description: T.t('r_report_active_year_student_info'),
                    isViewing: false,
                    redirectUrl: '/Report/StudentActiveTermReport',
                    reportTemplateGuid: ''
                },
                {
                    type: 2,
                    name: T.t('r_report_lesson_class'),
                    description: T.t('r_report_lesson_class_info'),
                    isViewing: false,
                    redirectUrl: '/Report/CourseBasedClassReport',
                    reportTemplateGuid: ''
                },
                {
                    type: 2,
                    name: T.t('r_report_branch_report'),
                    description: T.t('r_report_branch_report_info'),
                    isViewing: false,
                    redirectUrl: '/Report/SummaryCourseReport',
                    reportTemplateGuid: ''
                },
                {
                    type: 2,
                    name: T.t('r_report_system_access'),
                    description: T.t('r_report_system_access_info'),
                    isViewing: false,
                    redirectUrl: '/Report/SystemLoginReport',
                    reportTemplateGuid: ''
                },
                {
                    type: 2,
                    name: T.t('r_report_teacher_stats'),
                    ReportFileName: 'StudentStatsByProgram',
                    description: T.t('r_report_teacher_stats_info'),
                    isViewing: false,
                    redirectUrl: '/Report/GetReport',
                    ReportParameters: "10",
                    reportTemplateGuid: ''
                },
                {
                    type: 2,
                    name: T.t('r_report_student_program'),
                    ReportFileName: 'StudentsByProgram',
                    description: T.t('r_report_student_program_info'),
                    isViewing: false,
                    redirectUrl: '/Report/GetReport',
                    ReportParameters: "20",
                    reportTemplateGuid: ''
                },
                {
                    type: 3,
                    name: T.t('r_report_user_access'),
                    description: T.t('r_report_user_access_info'),
                    isViewing: false,
                    redirectUrl: '/Report/PersonelLoginReport',
                    reportTemplateGuid: ''
                },
                {
                    type: 3,
                    name: T.t('r_report_detail_user'),
                    ReportFileName: 'DetailUserReport',
                    description: T.t('r_report_detail_user_info'),
                    isViewing: false,
                    redirectUrl: '/Report/GetReport',
                    ReportParameters: "21",
                    reportTemplateGuid: ''
                },
                {
                    type: 3,
                    name: T.t('r_report_teacher_report'),
                    ReportFileName: 'TeacherReport',
                    description: T.t('r_report_detail_user_info'),
                    isViewing: false,
                    redirectUrl: '/Report/GetReport',
                    ReportParameters: "20",
                    reportTemplateGuid: ''
                },
                {
                    type: 4,
                    name: T.t('r_report_hourly_exam'),
                    description: T.t('r_report_hourly_exam_info'),
                    isViewing: false,
                    redirectUrl: '/Report/HourBasedExamReport',
                    reportTemplateGuid: ''
                },
                {
                    type: 4,
                    name: T.t('r_report_exam_control'),
                    description: T.t('r_report_exam_control_info'),
                    isViewing: false,
                    redirectUrl: '/Report/ExamControlReport',
                    reportTemplateGuid: ''
                },
                {
                    type: 4,
                    name: T.t('r_report_question_stats'),
                    description: T.t('r_report_question_stats_info'),
                    isViewing: false,
                    redirectUrl: '/Report/QuestionStatisticReport',
                    reportTemplateGuid: ''
                },
                {
                    type: 5,
                    name: T.t('r_report_help_desk_users'),
                    description: T.t('r_report_help_desk_users_info'),
                    isViewing: false,
                    redirectUrl: '/Report/HelpdeskAssigneeReport',
                    reportTemplateGuid: ''
                }
            ],
            redirect: false,
            baseRedirectUrl: '',
            reportFileName: ''
        };
    }

    toggleReport = (reportName: string) => {
        const updatedReports = this.state.reports.map((report: any) =>
            report.name === reportName ? { ...report, isViewing: true } : { ...report, isViewing: false }
        );
        this.setState({
            reports: updatedReports
        });
    };

    getReportStyle = (type: number) => {
        switch (type) {
            case 1:
            case 5:
                return {
                    icon: 'layers',
                    color: '#000000',
                    backgroundColor: '#e7e4ee'
                };
            case 2:
                return {
                    icon: 'view_list',
                    color: '#941d1d',
                    backgroundColor: '#fcccc2'
                };
            case 3:
                return {
                    icon: 'people',
                    color: '#3b8e69',
                    backgroundColor: '#e2f4eb'
                };
            case 4:
                return {
                    icon: 'layers',
                    color: '#030303',
                    backgroundColor: '#d9f0ff'
                };
            case 6:
                return {
                    icon: 'star',
                    color: '#e69319',
                    backgroundColor: '#fff5e6'
                };

            default:
                break;
        }
    };

    toggleRedirect = (redirectUrl: string, fileName: string) => {
        this.setState({
            redirect: true,
            baseRedirectUrl: redirectUrl,
            reportFileName: fileName
        });
    };

    componentDidMount() {
        let model = {
            ReturnUrl: '/Report'
        }
        this.props.dispatch(IFrameActions.getIFrameSource(model));
    }

    renderCollapsibleReport(reportType: number, reportState: any) {
        const isOpen = this.state[reportState] === this.state.row1status ? (this.state.row1status || this.state.searchResults.length > 0) : this.state[reportState]
        return (
            <Collapse isOpen={isOpen}>
                <div className="row report-row-expanded">
                    {this.state.reports
                        .filter((report: any) => report.type === reportType)
                        .map((report: any) => {
                            const reportStyle = this.getReportStyle(report.type);
                            const reportFileName = report.ReportFileName ? report.ReportFileName : '';
                            return (
                                <div className="col-md-3 report-card-container" style={{minHeight: "300px", height: "unset", minWidth: "250px"}} key={report.name}>
                                    <div
                                        className="report-card-image"
                                        style={{
                                            backgroundColor: reportStyle!.backgroundColor
                                        }}
                                    >
                                        <i
                                            className="material-icons report-row-icon-content"
                                            style={{
                                                fontSize: '36px',
                                                color: reportStyle!.color
                                            }}
                                        >
                                            {reportStyle!.icon}
                                        </i>
                                    </div>
                                      <div style={{whiteSpace: "pre-line"}}
                                      
                                      ><h4 
                                            style={{
                                                fontSize: '16px',
                                                lineHeight: '28px',
                                                textAlign: 'center'
                                            }}
                                        >  
                                            {report.name}
                                        </h4>
                                        </div>  
                                    
                                    <p className="report-card-description report-card-description-wrap">{report.description}</p>
                                    <div style={{marginBottom: "55px"}}><button
                                        className="report-card-view-link"
                                        style={{
                                            color: '#0099ff',
                                            textDecoration: 'underline',
                                            border: 'none',
                                            background: 'none',
                                            paddingBottom: '10px'
                                        }}
                                        onClick={() => report.redirectUrl ? this.toggleRedirect(report.redirectUrl, reportFileName) : this.toggleReport(report.name)}
                                    >
                                        {T.t('r_activity_processing_view_report')}
                                    </button>
                                    </div>
                                </div>
                            );
                        })}
                </div>
            </Collapse>
        );
    }

    onClickSearchBox = () =>
    {

        let searchBoxValue = true;

        if (this.state.isSearchBoxOpen === true)
        {
            searchBoxValue  = false;
        }

        this.setState({isSearchBoxOpen: searchBoxValue});
    }

    public render() {
        if (this.state.redirect) {
            const sourceUrl = this.state.reportFileName && this.state.reportFileName.length > 0 ? this.state.baseRedirectUrl + "&fileName=" + this.state.reportFileName : this.state.baseRedirectUrl
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/current?sourceUrl=' + sourceUrl} />;
        }
        return (
            <div>
                <div className="student-course" style={{ height: '100vh' }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <Loading spinnerId={'getUserHomeMyCourses'} />

                                <div className="d-flex justify-content-between student-course-header pd-top-30">
                                    <div>
                                        <h2 style={{ color: '#323231', fontSize: '20px' }}>{T.t('r_menu_report')}</h2>
                                    </div>
                                    <div className="lead-search-bar">
                                        <div className="question-filter p-0">
                                            <div className="options">
                                                <button
                                                    className="ml-3 mr-3"
                                                    onClick={() => this.onClickSearchBox()}

                                                    style={{ display: this.state.isSearchBoxOpen ? 'none' : 'block', border: 'none', background: 'none' }}
                                                >
                                                    <i className="material-icons mr-2 align-middle">search</i>
                                                    {T.t('r_gen_search')}
                                                </button>
                                            </div>
                                            <div
                                                id="assignment-search"
                                                className={this.state.isSearchBoxOpen ? 'search collapse show' : 'search collapse'}
                                                style={{ position: 'inherit' }}
                                            >
                                                <div className="input-group">
                                                    <div
                                                        data-toggle="collapse"
                                                        className="input-group-prepend collapsed"
                                                        aria-expanded="false"
                                                    >
                                                        <div
                                                            className="input-group-text"
                                                            onClick={() => {
                                                                this.setState({
                                                                    ...this.state,
                                                                    query: '',
                                                                    searchResults: [],
                                                                    isSearchBoxOpen: !this.state.isSearchBoxOpen
                                                                });
                                                            }}
                                                        >
                                                            <i className="material-icons">close</i>
                                                        </div>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="inlineFormInputGroup"
                                                        placeholder={T.t('r_gen_search')}
                                                        value={this.state.query}
                                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                            const regExp = new RegExp(event.target.value, 'i');

                                                            this.setState({
                                                                query: event.target.value,
                                                                searchResults: event.target.value
                                                                    ? this.state.reports.filter((report: any) => report.name.match(regExp))
                                                                    : []
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ul className="student-course-list list-unstyled">
                                    <li key={'reports-row-1'}>
                                        <div
                                            className="row"
                                            style={{
                                                margin: '10px 5px',
                                                cursor: 'pointer',
                                                display: this.state.searchResults.length > 0 ? 'none' : 'flex'
                                            }}
                                            // tslint:disable-next-line: jsx-no-lambda
                                            onClick={() => this.setState({ row1status: !this.state.row1status })}
                                        >
                                            <div className="col-md-12 align-self-center" style={{paddingInlineStart: "0px"}}>
                                                <div
                                                    className="report-row-image"
                                                    style={{
                                                        backgroundColor: '#e7e4ee'
                                                    }}
                                                >
                                                    <i
                                                        className="material-icons report-row-icon"
                                                        style={{
                                                            color: '#000000'
                                                        }}
                                                    >
                                                        layers
                                                    </i>
                                                </div>
                                                <div className="list-content d-inline-block" style={{paddingInlineStart: "10px"}}>
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start"}}>
                                                        {T.t('r_report_teacher_detail')}
                                                    </h5>
                                                    <p>{T.t('r_report_teacher_detail_info')}</p>
                                                </div>
                                            </div>
                                        </div>
                                        {this.renderCollapsibleReport(1, 'row1status')}
                                    </li>
                                    <li key={'reports-row-2'}>
                                        <div
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            // tslint:disable-next-line: jsx-no-lambda
                                            onClick={() => this.setState({ row2status: !this.state.row2status })}
                                        >
                                            <div className="col-md-12 align-self-center" style={{paddingInlineStart: "0px"}}>
                                                <div
                                                    className="report-row-image"
                                                    style={{
                                                        backgroundColor: '#fcccc2'
                                                    }}
                                                >
                                                    <i
                                                        className="material-icons report-row-icon"
                                                        style={{
                                                            color: '#8a0f0f'
                                                        }}
                                                    >
                                                        view_list
                                                    </i>
                                                </div>
                                                <div className="list-content d-inline-block" style={{paddingInlineStart: "10px"}}>
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start" }}>
                                                        {T.t('r_report_system')}
                                                    </h5>
                                                    <p>{T.t('r_report_system_info')}</p>
                                                </div>
                                            </div>
                                        </div>
                                        {this.renderCollapsibleReport(2, 'row2status')}
                                    </li>

                                    <li key={'reports-row-3'}>
                                        <div
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            // tslint:disable-next-line: jsx-no-lambda
                                            onClick={() => this.setState({ row3status: !this.state.row3status })}
                                        >
                                            <div className="col-md-12 align-self-center" style={{paddingInlineStart: "0px"}}>
                                                <div
                                                    className="report-row-image"
                                                    style={{
                                                        backgroundColor: '#e2f4eb'
                                                    }}
                                                >
                                                    <i
                                                        className="material-icons report-row-icon"
                                                        style={{
                                                            color: '#3b8e69'
                                                        }}
                                                    >
                                                        people
                                                    </i>
                                                </div>
                                                <div className="list-content d-inline-block" style={{paddingInlineStart: "10px"}}>
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start" }}>
                                                        {T.t('r_report_user')}
                                                    </h5>
                                                    <p>{T.t('r_report_user_info')}</p>
                                                </div>
                                            </div>
                                        </div>
                                        {this.renderCollapsibleReport(3, 'row3status')}
                                    </li>

                                    <li key={'reports-row-4'}>
                                        <div
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            // tslint:disable-next-line: jsx-no-lambda
                                            onClick={() => this.setState({ row4status: !this.state.row4status })}
                                        >
                                            <div className="col-md-12 align-self-center" style={{paddingInlineStart: "0px"}}>
                                                <div
                                                    className="report-row-image"
                                                    style={{
                                                        backgroundColor: '#d9f0ff'
                                                    }}
                                                >
                                                    <i
                                                        className="material-icons report-row-icon"
                                                        style={{
                                                            color: '#000000'
                                                        }}
                                                    >
                                                        layers
                                                    </i>
                                                </div>
                                                <div className="list-content d-inline-block" style={{paddingInlineStart: "10px"}}>
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start" }}>
                                                        {T.t('r_report_exam')}
                                                    </h5>
                                                    <p>{T.t('r_report_exam_info')}</p>
                                                </div>
                                            </div>
                                        </div>
                                        {this.renderCollapsibleReport(4, 'row4status')}
                                    </li>

                                    <li key={'reports-row-5'}>
                                        <div
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            // tslint:disable-next-line: jsx-no-lambda
                                            onClick={() => this.setState({ row5status: !this.state.row5status })}
                                        >
                                            <div className="col-md-12 align-self-center" style={{paddingInlineStart: "0px"}}>
                                                <div
                                                    className="report-row-image"
                                                    style={{
                                                        backgroundColor: '#e7e4ee'
                                                    }}
                                                >
                                                    <i
                                                        className="material-icons report-row-icon"
                                                        style={{
                                                            color: '#000000'
                                                        }}
                                                    >
                                                        layers
                                                    </i>
                                                </div>
                                                <div className="list-content d-inline-block" style={{paddingInlineStart: "10px"}}>
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start" }}>
                                                        {T.t('r_report_help_desk')}
                                                    </h5>
                                                    <p>{T.t('r_report_help_desk_info')}</p>
                                                </div>
                                            </div>

                                        </div>
                                        {this.renderCollapsibleReport(5, 'row5status')}
                                    </li>

                                    <li key={'reports-row-6'}>
                                        <div
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            // tslint:disable-next-line: jsx-no-lambda
                                            onClick={() => this.setState({ row6status: !this.state.row6status })}
                                        >
                                            <div className="col-md-12 align-self-center" style={{paddingInlineStart: "0px"}}>
                                                <div
                                                    className="report-row-image"
                                                    style={{
                                                        backgroundColor: '#fff5e6'
                                                    }}
                                                >
                                                    <i
                                                        className="material-icons report-row-icon"
                                                        style={{
                                                            color: '#e69319'
                                                        }}
                                                    >
                                                        star
                                                    </i>
                                                </div>
                                                <div className="list-content d-inline-block" style={{paddingInlineStart: "10px"}}>
                                                    <h5 className="mt-1 mb-0" style={{ marginBottom: 2.5, textAlign: "start" }}>
                                                        {T.t('r_report_special_report')}
                                                    </h5>
                                                    <p>{T.t('r_report_special_report_info')}</p>
                                                </div>
                                            </div>

                                        </div>
                                        {this.renderCollapsibleReport(6, 'row6status')}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: any) => {
    if (!state) {
        return ownProps;
    }
    const newProps: any = Object.assign({}, ownProps, {
        userPreferences: state.profile.userPreferences.preferences,
        iFrameSource: state.iFrame.iFrameSource
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.iFrame.iFrameSource === prev.iFrame.iFrameSource;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CReportPage = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(ReportPage);

export default CReportPage;
